export default "__VITE_ASSET__4908b030__"